import * as THREE from "three";
import Light from "@/models/Light";

export default function(x, y, z, rotX, rotY, rotZ) {
  function Knob(x2, y2, z2, material) {
    Object.setPrototypeOf(this, new THREE.Object3D());
    this.position.set(x2, y2, z2);

    const geometryInner = new THREE.CylinderBufferGeometry(1.2, 1.2, 1, 64);
    const geometryOuter = new THREE.TorusBufferGeometry(0.95, 0.6, 10, 64);

    const meshInner = new THREE.Mesh(geometryInner, material);
    const meshOuter = new THREE.Mesh(geometryOuter, material);
    meshOuter.rotation.x = Math.PI / 2;

    this.add(meshInner);
    this.add(meshOuter);
  }

  function Grip(x2, y2, z2, material) {
    Object.setPrototypeOf(this, new THREE.Object3D());
    this.position.set(x2, y2, z2);

    const geometry = new THREE.CylinderBufferGeometry(1, 1, 20);
    const mesh = new THREE.Mesh(geometry, material);

    this.add(mesh);
  }

  function Barrel(x2, y2, z2, material) {
    Object.setPrototypeOf(this, new THREE.Object3D());
    this.position.set(x2, y2, z2);

    const _cloud = [];
    let j = 1;
    let aux;

    for (let i = 0; i <= 50; i += 0.1) {
      if (i <= 10) {
        j += i * 0.0005;
      } else if (i > 10 && i <= 18) {
        j += i * 0.001;
      } else if (i > 18 && i <= 25) {
        j += i * 0.0005;
      } else if (i > 30 && i <= 48) {
        aux = j;
      } else if (i > 48) {
        j = -((aux / 2) * i) + aux * 25;
      }
      _cloud.push(new THREE.Vector3(j, i, 0)); // Inserción de Puntos en el Arreglo
    }

    const geometryBarrel = new THREE.LatheBufferGeometry(_cloud);
    const geometryLimit = new THREE.TorusBufferGeometry(0.6, 2.5, 10, 64);

    const meshBarrel = new THREE.Mesh(geometryBarrel, material);
    const meshLimit = new THREE.Mesh(geometryLimit, material);
    meshLimit.position.y = 48;
    meshLimit.rotation.x = Math.PI / 2;

    this.add(meshBarrel);
    this.add(meshLimit);
  }

  Object.setPrototypeOf(this, new THREE.Object3D());
  this.position.set(x, y, z);
  this.rotation.set(rotX, rotY, rotZ);

  const textureLoader = new THREE.TextureLoader();
  const textureWood = textureLoader.load("/img/3DTextures/baseballBate/wood.png");
  const textureTape = textureLoader.load("/img/3DTextures/baseballBate/tape.jpg");

  const materialWood = new THREE.MeshPhongMaterial({ map: textureWood });
  const materialTape = new THREE.MeshPhongMaterial({ map: textureTape });

  const light1 = new Light(0, 40, 35, 0xffffff);
  const light2 = new Light(40, -40, 35, 0xffffff);
  const light3 = new Light(-40, 0, -35, 0xffffff);
  const knob = new Knob(0, -10, 0, materialWood);
  const grip = new Grip(0, 0, 0, materialTape);
  const barrel = new Barrel(0, 10, 0, materialWood);

  this.add(light1);
  this.add(light2);
  this.add(light3);
  this.add(knob);
  this.add(grip);
  this.add(barrel);
}
